import { ReactElement } from 'react';
import ModalImg from 'src/assets/images/create-menu-modal.png';
import { ModalWrapper } from 'src/components';
import MenuModalContent from './MenuModalContent';
import { IMenuModal } from './types';

const MenuModal = ({
  menuName,
  title,
  closeModal,
  open,
  variant,
  id,
  consumerName,
  image,
}: IMenuModal): ReactElement => {
  return (
    <ModalWrapper closeModal={closeModal} open={open} image={ModalImg} imageAlt="Picture of menus">
      <MenuModalContent
        menuName={menuName}
        title={title}
        variant={variant}
        id={id}
        consumerName={consumerName}
        image={image}
        closeModal={closeModal}
      />
    </ModalWrapper>
  );
};

export default MenuModal;
